// extracted by mini-css-extract-plugin
export default {"warningIcon":"fastest-rule-validation_warningIcon__YBiAe","link":"fastest-rule-validation_link__97C9o"};